// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge__badge-f9f954 {
  display: inline-block;
  border-radius: 50px;
  box-sizing: border-box;
  padding: 0 8px;
  min-width: 24px;
  min-height: 24px;
  text-align: center;
  font: var(--font-caption-1);
  line-height: 24px;
  letter-spacing: var(--font-spacing-caption-1);
  background-color: var(--brand-primary-40);
  color: var(--addition-50);
}

.Badge__is-muted-ea1eb5 {
  background-color: var(--base-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Badge/Badge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,6CAAA;EACA,yCAAA;EACA,yBAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".badge {\n  display: inline-block;\n  border-radius: 50px;\n  box-sizing: border-box;\n  padding: 0 8px;\n  min-width: 24px;\n  min-height: 24px;\n  text-align: center;\n  font: var(--font-caption-1);\n  line-height: 24px;\n  letter-spacing: var(--font-spacing-caption-1);\n  background-color: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n\n.is-muted {\n  background-color: var(--base-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `Badge__badge-f9f954`,
	"is-muted": `Badge__is-muted-ea1eb5`,
	"isMuted": `Badge__is-muted-ea1eb5`
};
module.exports = ___CSS_LOADER_EXPORT___;
